import { RangePresetsDefault } from "@src/constant/default-range-picker-presets";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { trackEventPayload } from "@src/util/track-event-payload";
import { DatePicker, DatePickerProps, Form } from "antd";
import { FormInstance } from "antd/lib/form";
import { useTracking } from "react-tracking";
import { generalStyleFormExtraItem } from "../modal-content";

const { RangePicker } = DatePicker;
export const ExtraInstallDate: React.FC<{ form: FormInstance }> = () => {
  const { trackEvent } = useTracking();
  const disabled31DaysDate: DatePickerProps["disabledDate"] = (current, { from }) => {
    if (from) {
      return Math.abs(current.diff(from, "days")) >= 31;
    }
    return false;
  };

  return (
    <Form.Item {...generalStyleFormExtraItem} name={FilterFormFieldsEnum.EXTRA_INSTALL_DATE} label="Install Date">
      <RangePicker
        className="w-full"
        presets={RangePresetsDefault}
        onChange={(_, dateStrings) => {
          trackEvent(
            trackEventPayload.extraFieldFilter("field_update", {
              [FilterFormFieldsEnum.EXTRA_INSTALL_DATE]: dateStrings,
            }),
          );
        }}
      />
    </Form.Item>
  );
};
